import React, { useState,useEffect } from "react";
import { dateFormator, mapTableRows } from "../../../../../utils";
import {
  Backdrop,
  Button,
  Divider,
  Modal,
  DocumentsList,
  LogoLoader,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPlacementsData,
  getAllPlacementsStart,
} from "../../../../../redux/slices/placements/placementsSlice";
import dayjs from "dayjs";

const Active = ({ clientId }) => {
  const dispatch = useDispatch();
  const { placements: placementsTableData, isLoading } = useSelector(
    (state) => state?.placement
  );

  const [selectedDocuments, setSelectedDocuments] = useState([]);

  console.log("placements for client in active", placementsTableData?.data);
  useEffect(() => {
    if (clientId) {
      dispatch(
        getAllPlacementsStart({
          fil: {
            "jobInfo.billClient": { type: "NONE", value: clientId },
            // entityId: { type: "NONE", value: clientId },
            // "jobInfo.entityType": { type: "NONE", value: "Client" },
            "jobInfo.endDate": { type: "GT", value: dayjs().startOf("day") },
          },
          ref: "Employee Vendor",
          incl: ["firstName lastName employmentType"],
        })
      );
    }
    return () => {
      dispatch(clearPlacementsData());
    };
  }, [clientId]);

  const EmploymentType = {
    1: "Regular",
    2: "Consultant",
    3: "Contractor",
  };

  // const tableData2 = placementsTableData?.data?.map((item) => ({
  //   uiid: item.uiid,
  //   consultantName: `${item?.employeeId?.firstName || ""} ${
  //     item?.employeeId?.lastName || ""
  //   }`,
  //   consultantType:
  //     EmploymentType[item?.employeeId?.employmentType] || "Employee",
  //   jobTitle: item?.jobInfo?.jobTitle || "-",
  //   jobCode: item?.jobInfo?.jobCode || "-",
  //   vendor: "--",
  //   startDate: item?.jobInfo?.startDate || "-",
  //   endDate: item?.jobInfo?.endDate || "-",
  //   poNumber: item?.payments?.[0]?.poNum
  //     ? `PO# ${item?.payments[0].poNum}`
  //     : "PO# -",
  //   poLink: item?.payments?.flatMap((payment) => payment?.poLink || []),
  // }));
const tableData2 = Array.from(
  new Map(
    placementsTableData?.data?.map((item) => [
      item.uiid,
      {
        uiid: item.uiid,
        consultantName: `${item?.employeeId?.firstName || ""} ${item?.employeeId?.lastName || ""}`,
        consultantType: EmploymentType[item?.employeeId?.employmentType] || "Employee",
        jobTitle: item?.jobInfo?.jobTitle || "-",
        jobCode: item?.jobInfo?.jobCode || "-",
        vendor: item?.vendor?.id?.businessName || "-",
        startDate: item?.jobInfo?.startDate || "-",
        endDate: item?.jobInfo?.endDate || "-",
        poNumber: item?.payments?.[0]?.poNum ? `PO# ${item?.payments[0].poNum}` : "-",
        poLink: item?.payments?.flatMap((payment) => payment?.poLink || []),
      },
    ])
  ).values()
);


  const tableData = [
    {
      consultantName: "Ravindra Rao ",
      consultantType: "Employee",
      jobTitle: "IBM BPM Developer_NET Esolutions",
      jobCode: "NETE-001",
      vendor: "--",
      startDate: "2019-02-01T18:30:00.000Z",
      endDate: "2025-12-30T18:30:00.000Z",
      poNumber: "PO# N-240051",
    },
    {
      consultantName: "Chandra Gundu",
      consultantType: "Contract",
      jobTitle: "Sr. Net Developer",
      jobCode: "NDSFL-002",
      vendor: "RAMPS International Inc",
      startDate: "2022-10-06T18:30:00.000Z",
      endDate: "2025-12-30T18:30:00.000Z",
      poNumber: "PO# N-240051",
    },
  ];
  const columns = [
    {
      key: "consultantName",
      label: "Consultant Name",
    },

    {
      key: "consultantType",
      label: "Consultant Type",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "jobCode",
      label: "Job Code",
    },
    {
      key: "vendor",
      label: "Vendor",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
    },
    {
      key: "poNumber",
      label: "PO Number",
    },

    {
      key: "purchaseOrder",
      label: "Purchase Order",
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={"download"}
            color="black"
            size="sm"
            onClick={() => setSelectedDocuments(row.poLink.map((item) => ({
              filePath: item,
              name:row?.poNumber || "-"
            })))}
          />
          <Button
            type="icon"
            variant="text"
            icon={"history"}
            color="black"
            size="sm"
          />
        </div>
      ),
    },
  ];

  // const mappedRows = mapTableRows(tableData, columns);
  const mappedRows = mapTableRows(tableData2, columns);
  const linkedplacementTableData = [
    // {
    //   consultantName: "LaTara Leshica",
    //   consultantType: "Electronics Technician Level 2",
    //   jobTitle: "FE001",
    //   billableClient: "Freedom Electronics",
    //   linkedAs: "End Client",
    //   placementType: "Permanent Placement",
    // },
  ];
  const linkedplacementColumns = [
    {
      key: "consultantName",
      label: "Consultant Name",
    },

    {
      key: "consultantType",
      label: "Consultant Type",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[300px]!",
    },
    {
      key: "billableClient",
      label: "Billable Client",
    },
    {
      key: "linkedAs",
      label: "Linked As",
    },
    {
      key: "placementType",
      label: "Placement Type",
    },
  ];

  const linkedplacementmappedRows = mapTableRows(
    linkedplacementTableData,
    linkedplacementColumns,
  );
  return (
    <>
      <Modal
        isOpen={selectedDocuments.length > 0}
        onClose={() => setSelectedDocuments([])}
        width="max-w-2xl"
        title={"Document Details"}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <div className="py-3 ">
        <TableAdv
          tableId={`clients_placements_active`}
          columns={columns}
          rows={mappedRows}
          hideToolBar
        />
        <div className="mt-4">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"LINKED PLACEMENTS "} tag="p" />
              </div>
            }
          />
        </div>
        <Divider className="mb-3" />
        <TableAdv
          tableId={`clients_placements_active_linkedplacements`}
          columns={linkedplacementColumns}
          rows={linkedplacementmappedRows}
          hideToolBar
        />
        <div className="mt-4">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ACTIVITIES"} tag="p" />
              </div>
            }
          />
        </div>
        <Divider className="mb-3" />
      </div>
    </>
  );
};

export default Active;
